<template>
    <div class="MeetingMentorReportFilterBar">
        <div class="container-fluid">
            <div class="row vertical-align margin-Top-2Perc margin-bottom-2Perc"> 
                <div class="col-md-2 col-lg-2 text-align-right padding-left-right-0Px">
                    Group
                </div>    
                <div class="col-md-3 col-lg-3">
                    <div class="form-group">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
                            <select class="form-control" v-model="currSelectedGroupObj">
                              <option value='-1' disabled>Select</option>
                              <option v-for="groupObj in getGroupListValue" v-bind:key="groupObj.GroupId" v-bind:value="groupObj">{{ groupObj.GroupName }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-md-1 col-lg-1 text-align-right padding-left-right-0Px">
                    Cohort(s)
                </div>    
                <div class="col-md-3 col-lg-3">
                    <div class="form-group">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
                          <select class="form-control" v-model="getSelectedCohortObj">
                            <option value='-1' disabled>Select</option>
                            <option v-for="cohortObj in getCohortListValue" v-bind:key="cohortObj.CohortId" v-bind:value="cohortObj">{{ cohortObj.CohortName }}</option>
                          </select>
                        </div>
                    </div>
                </div>
                <div class="col-md-1 col-lg-1">
                  <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="checkAndEmit($event, false)">View</button>
                </div>
                <div class="col-md-1 col-lg-1">
                  <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="checkAndEmit($event, true)" v-if="getShowExportState">Export</button>
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
            </div>
            <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
            <!-- Show Spinner -->
            <div class="animationload" v-show="showSpinner">
              <div class="osahanloading"></div>
            </div>
            <loader></loader>      
        </div>
    </div>    
</template>

<script>
import {isEqual, isEmpty} from 'lodash'
import { constants } from '@/utils/constants'
import { groupService } from '@/server-util/group-service'
import { groupCourseService } from '@/server-util/group-course-service'
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
export default {
  props: ['showExport', 'currentSelectedTab'],
  created: function () {
    this.setDefaultValues()
    this.getGroupList()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      currSelectedGroupObj: -1,
      currSelectedCohortObj: -1,
      cohortList: []
    }
  },
  methods: {
    getGroupList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        // AK: Check weather Grouplist is already present or not?
        if (storeObj.state.groupList.length === 0) {
          this.$store.state.isLoading = true
        }
        groupService
          .listGroups(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupList = responseObj.data
              this.$store.state.isLoading = false
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING GROUP LIST'
        )
      }
    },
    setDefaultValues: function () {
      if (!isEmpty(this.$store.state.selectedGroupCourseObj)) {
        this.currSelectedGroupObj = this.$store.state.selectedGroupCourseObj
      }
      if (!isEmpty(this.$store.state.selectedCohortObj)) {
        this.currSelectedCohortObj = this.$store.state.selectedCohortObj
      }
    },
    checkAndEmit: function (event, isExportBtnClicked) {
      if (this.currSelectedGroupObj !== -1) {
        if (this.currSelectedCohortObj !== -1) {
          // AK: Emit selected Group and cohort obj
          this.$emit('selectedGroupObj', this.currSelectedGroupObj)
          this.$emit('selectedCohortObj', this.currSelectedCohortObj)
          // this.$store.state.selectedGroupCourseObj = this.currSelectedGroupObj
          // this.$store.state.selectedCohortObj = this.currSelectedCohortObj
          if (isExportBtnClicked) {
            this.$emit('isExportBtnClicked', true)
            this.$emit('isViewBtnClicked', false)
          } else {
            this.$emit('isExportBtnClicked', false)
            this.$emit('isViewBtnClicked', true)
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg =
            'Please select a cohort.'
        }
      } else {
        this.showAlertDialog = true
        this.errorMsg =
          'Please select a group.'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getAssociatedCohortList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '' &&
        this.currSelectedGroupObj !== undefined && this.currSelectedGroupObj !== 'undefined' && this.currSelectedGroupObj !== null && this.currSelectedGroupObj !== 'null' && this.currSelectedGroupObj !== '' && this.currSelectedGroupObj !== -1
      ) {
        this.$store.state.isLoading = true
        groupCourseService
          .listGroupCourseCohortForMeetingMentor(
            storeObj.state.access_token,
            this.currSelectedGroupObj.GroupId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.cohortList = responseObj.data
              if (this.cohortList.length === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No cohort(s) found in "' + this.currSelectedGroupObj.GroupName + '" group.'
                this.cohortList = []
                this.currSelectedCohortObj = -1
              }
              this.$store.state.isLoading = false
            } else {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'GroupId is NULL hence declined Loading GROUP COURSE COHORT List.'
        )
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader
  },
  computed: {
    currentSelectedTabValue: {
      get: function () {
        return this.currentSelectedTab
      }
    },
    getGroupListValue: {
      get: function () {
        return this.$store.state.groupList
      }
    },
    getCohortListValue: {
      get: function () {
        return this.cohortList
      },
      set: function (newValue) {
        this.cohortList = newValue
      }
    },
    getSelectedCohortObj: {
      get: function () {
        return this.currSelectedCohortObj
      },
      set: function (newValue) {
        this.currSelectedCohortObj = newValue
      }
    },
    getShowExportState: {
      get: function () {
        return this.showExport
      }
    }
  },
  watch: {
    currSelectedGroupObj: function () {
      // AK: Reset Selected Cohort Obj to -1 again
      if (!isEqual(this.currSelectedGroupObj, this.$store.state.selectedGroupCourseObj)) {
        this.currSelectedCohortObj = -1
      }
      this.getAssociatedCohortList()
    },
    currentSelectedTabValue: function (newValue, oldValue) {
      console.log('newValue: ' + newValue + ' oldValue: ' + oldValue)
      if (newValue !== oldValue) {
        this.currSelectedGroupObj = -1
        this.currSelectedCohortObj = -1
      }
    }
  },
  name: 'MeetingMentorReportFilterBar'
}
</script>

<style scoped>
.MeetingMentorReportFilterBar {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.padding-left-right-0Px {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.btn {
  white-space: normal !important;
  word-wrap: break-word;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}

.align-center {
  margin: 0 auto !important;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-20px {
  font-size: 20px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5%;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.unenroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.text-align-right {
  text-align: right;
}
.padding-left-right-0Px {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/MeetingMentorReportFilterBar.vue